function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9994 5.83317V3.33317C14.9994 2.4165 14.2494 1.6665 13.3327 1.6665H6.66602C5.74935 1.6665 4.99935 2.4165 4.99935 3.33317V5.83317H4.16602V10.8332L6.66602 15.8332V18.3332H13.3327V15.8332L15.8327 10.8332V5.83317H14.9994ZM6.66602 3.33312H13.3327V5.83312H11.6577V4.16646H10.8243V5.83312H9.16602V4.16646H8.33268V5.83312H6.66602V3.33312ZM11.6658 15.4415L14.1658 10.4415V7.49988H5.8325V10.4415L8.3325 15.4415V16.6665H11.6658V15.4415Z"
}));

var SvgDevice = function SvgDevice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/device.6ecea7ad.svg";
export { ForwardRef as ReactComponent };